//Library imports
import styled from 'styled-components';
import { useEffect, useState } from 'react';
//Local imports

import classNames from 'classnames';
import SharedCard from './SharedCard';
import Triangle from 'assets/img/PublishMenu/Triangle.svg';
import ArrowDownIcon from 'assets/svgs/ArrowDownIcon';
import ArrowUpIcon from 'assets/svgs/ArrowUpIcon';
import { useHistory } from 'react-router-dom';
import { splitDayMonth } from '../utils';
import { useMediaQuery } from 'react-responsive';

const EditionCard = (props: any) => {
  const {
    emailType,
    scheduled_time,
    isScheduled = false,
    data,
    sent_date,
    sent_month,
    campaignId,
    showEmailStats,
    scheduledStyle = false,
    automation,
    isWFActionEmail,
    tabState,
    aiTagColor,
    aiTag,
    generationId,
    aiEmails,
    collapse,
    isWorkflowEmailsList,
  } = props;
  const [date, setDate] = useState('');
  const [month, setMonth] = useState('');
  const history = useHistory();
  const [toggle, setToggle] = useState(false);

  const splitDayMonthOfEmail = () => {
    const myArr = data.sent_date.split(',')[0].split(' ');
    setMonth(myArr[0]?.toString());
    setDate(myArr[1]?.toString());
  };

  useEffect(() => {
    if (data.sent_date !== null) {
      splitDayMonthOfEmail();
    }
  }, [data.sent_date]);

  const MaxWidthApp = () => {
    const isResolution = useMediaQuery({
      query: '(max-width: 1100px)',
    });
    return isResolution;
  };

  return (
    <Style
      isAiEmail={emailType === 2}
      isWorkflowEmailsList={isWorkflowEmailsList}
      className={classNames('collapse-wrapper', { activeCollapseWrap: toggle })}
    >
      <SharedCard
        emailType={emailType}
        scheduled_time={scheduled_time}
        isScheduled={isScheduled}
        sent_date={sent_date}
        sent_month={sent_month}
        campaignId={campaignId}
        showEmailStats={showEmailStats}
        scheduledStyle={scheduledStyle}
        automation={automation}
        isWFActionEmail={isWFActionEmail}
        tabState={tabState}
        generationId={generationId}
        collapse={collapse}
        date={date}
        month={month}
        data={data}
        parentCollapse
        parentLinear={emailType === 2 && aiTagColor.includes(',') ? `linear-gradient(${aiTagColor})` : aiTagColor}
        isWorkflowEmailsList={isWorkflowEmailsList}
      />
      {emailType === 2 && !toggle && (
        <div className="toggle-show" onClick={() => setToggle(true)}>
          Show All ({aiEmails?.length})<img src={Triangle} style={{ marginLeft: '5px', transform: 'rotate(180deg)' }} height="10px" width="10px" />
        </div>
      )}
      {/* {emailType === 2 ? (
          <ShowAllCollapse onClick={() => setToggle(!toggle)}>
            <span className="btn-trigger">
              {' '}
              {MaxWidthApp() ? null : 'Show All'} {!toggle ? <ArrowDownIcon /> : <ArrowUpIcon />}
            </span>
          </ShowAllCollapse>
        ) : (
          <></>
        )} */}
      {/* </SharedCard> */}
      {!!aiEmails?.length && (
        <>
          <CollapseArea className={classNames({ show: toggle })}>
            {aiEmails.map((aiEmail: any) => {
              return (
                <SharedCard
                  emailType={aiEmail.email_type}
                  isScheduled={isScheduled}
                  {...(aiEmail.scheduled_time
                    ? {
                        sent_date: aiEmail.date !== null && aiEmail.date.split(' ')[0],
                        sent_month: aiEmail.date !== null && aiEmail.date.split(' ')[1],
                      }
                    : {
                        sent_month: splitDayMonth(aiEmail.sent_date).month,
                        sent_date: splitDayMonth(aiEmail.sent_date).date,
                      })}
                  {...(isScheduled ? { scheduled_time: aiEmail.scheduled_time } : {})}
                  campaignId={campaignId}
                  showEmailStats={showEmailStats}
                  scheduledStyle={scheduledStyle}
                  automation={automation}
                  isWFActionEmail={isWFActionEmail}
                  tabState={tabState}
                  aiTag={aiEmail.ai_type}
                  generationId={aiEmail.generation_id}
                  collapse={collapse}
                  date={date}
                  month={month}
                  data={aiEmail}
                  childCollapse
                  childColor={aiEmail.ai_color}
                />
              );
            })}
          </CollapseArea>
          {emailType === 2 && toggle && (
            <div className="toggle-show" onClick={() => setToggle(false)}>
              Show Less <img src={Triangle} style={{ marginLeft: '5px' }} height="10px" width="10px" />
            </div>
          )}
        </>
      )}
    </Style>
  );
};

export default EditionCard;

EditionCard.defaultProps = {
  showEmailStats: true,
};

const CollapseArea = styled.div`
  display: none;
  &.show {
    display: block;
  }
`;

const ShowAllCollapse = styled.div`
  margin-left: 16px;
  display: inline-flex;
  align-items: flex-end;
  /* @media all and (max-width: 1100px) {
    width: 20px;
  } */
  .btn-trigger {
    flex-shrink: 0;
    display: inline-flex;
    min-width: 100px;
    padding: 5px 10px;
    border-radius: 6px;
    border: 1px solid #1ec252;
    background: #1ec252;
    color: #fff;
    text-align: center;
    font-family: 'Roboto';
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    align-items: center;
    justify-content: center;
    margin-bottom: 4px;
    cursor: pointer;
    white-space: nowrap;
    @media all and (max-width: 1100px) {
      padding: 5px;
      min-width: 20px;
    }
    svg {
      width: 10px;
      height: 8px;
      margin-left: 5px;
      @media all and (max-width: 1100px) {
        margin-left: 0px;
      }
      path {
        fill: #fff;
      }
    }
  }
`;

const Style = styled.div<{ isAiEmail: boolean; isWorkflowEmailsList: boolean }>`
  margin-bottom: 1em;
  position: relative;

  .card-style {
    &.parentAppend {
      background-color: #fff;
    }
  }

  &.activeCollapseWrap {
    /* border: 2px solid #1ec252; */
    border-radius: 8px;
    /* background-color: #fff; */
    .parentAppend {
      background-color: #fff;
      margin-bottom: 2px;
      border-radius: 10px;
      /* border-radius: 10px 10px 0px 0px; */
      /* border: none; */
    }
    .childAppend {
      border-radius: 8px;
      margin: 0px 0px 11px 0px;
      &:last-child {
        margin-bottom: 0px;
        border-radius: 8px 8px 0px 0px;
      }
    }
  }

  .left-side-image {
    .text-area {
      position: relative;
      /* width: calc(100% - 200px); */
      min-height: 67px;
      justify-content: flex-end;
      display: flex;
      flex-direction: column;
    }
  }

  .clickable {
    cursor: pointer;
  }
  .color-strip {
    margin-left: 1.5em;
    width: 11px;
    height: 94px;
    border-radius: 5px 0 0 5px;
    border-right: 1px solid #ffffff;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 7px;
      height: 67px;
      border-radius: 4px 0 0 4px;
      margin-left: 17px;
    }
  }
  .display-flex {
    display: flex;
  }
  .analytics-icon {
    /* width: 40%; */
    justify-content: flex-end;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      /* width: 30%; */
    }
    > div:nth-child(2) {
      /* min-width: 30px; */
      text-align: right;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      margin-bottom: 4px;
    }
  }
  .analytics-btn {
    cursor: pointer;
    svg {
      width: 26px;
      height: auto;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 20px;
      }
      path {
        fill: #27ce0a;
      }
    }
  }
  .disable-link {
    pointer-events: none;
    opacity: 0.5;
    /* .analytics-btn {
      opacity: 0.5;
    } */
  }
  .tags-container {
    display: flex;
    justify-content: end;
    align-items: center;
    height: auto;
  }
  .styling-tag {
    border: none;
    margin: 0;
    border-radius: 16px;
    color: #a3a3a3;
    vertical-align: middle;
    font-size: 12px;
    font-weight: 500;
    font-family: 'robotoregular';
    line-height: 16px;
    margin-top: 0px;
    margin-left: 3px;
    .icon-width {
      width: 18px;
      height: 18px;
      margin-right: 2px;
    }
    &.ai-type-tag {
      font-size: 10px !important;
      border-radius: 50%;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 22px;
      height: 22px;
      padding: 0px;
      padding-left: 2px;
      position: relative;
      .logo-img {
        height: 18px;
        width: 18px;
        min-width: 18px;
      }
    }
    &.email-tag {
      background-color: #f5f5f5 !important;
      font-family: 'Roboto';
      font-weight: 500;
      display: flex;
      align-items: center;
      padding: 4px 12px;
      font-size: 14px;
      letter-spacing: -0.417px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
        /* padding: 1px 10px 0px 8px; */
      }
    }
    &.pending-tag {
      background-color: #fff !important;
      color: #27ce0a;
      padding: 2px 13px;
      font-size: 12px;
      border: 2px solid #fff;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 10px;
      }
    }
    &.test-tag {
      color: #fff;
      background-color: #27ce0a !important;
      border-color: #27ce0a !important;
      margin-left: 5px;
    }
    &.error-tag {
      background-color: #ffe4e4 !important;
      color: #d22121;
    }
    &.automation-icon {
      padding: 3px 6px;
      background-color: #def6e6 !important;
      svg {
        width: 12px;
        height: auto;
        vertical-align: middle;
        g {
          fill: #27ce0a;
        }
      }
    }
  }
  .icon-text-styling {
    color: #5e7079;
    font-size: 12px;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 700;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 9px;
    }
  }
  .icon-styling {
    /* margin: 0 0.75em; */
    text-align: center;
    a {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    svg {
      margin-bottom: 2px;
      /* height: 16px; */
      /* width: auto; */
      /* margin: 0 auto; */
    }
    &.eye {
      svg path {
        fill: #000000;
        opacity: 0.5;
      }
    }
  }
  .article-text-style {
    color: #000000;
    font-size: 20px;
    line-height: 24px;
    font-family: 'Roboto Slab';
    font-weight: 500;
    margin-left: 10px;
    margin-bottom: 10px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
      line-height: 15px;
      height: 20px;
      margin-bottom: 0px;
    }
    .ant-typography-ellipsis-single-line {
      width: ${(props) => (props.isWorkflowEmailsList ? '32vw' : '20vw')};
      @media all and (max-width: 1200px) {
        width: ${(props) => (props.isWorkflowEmailsList ? '30vw' : '16vw')};
      }
    }
  }
  .subject {
    font-family: 'Roboto';
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: -0.2916666567325592px;
    color: #67696a;
    padding-left: 10px;
    .ant-typography-ellipsis-single-line {
      width: 16vw;
      @media all and (max-width: 1200px) {
        width: 12vw;
      }
    }
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      line-height: 13px;
      font-size: 10px;
    }
    .subject-label {
      font-weight: 400;
    }
    .subject-text {
      font-weight: 500;
      margin-left: 3px;
    }
  }
  .card-style {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f0efef;
    border-radius: ${(props) => (props.isAiEmail ? '10px 10px 0px 0px' : '10px')};
    /* border-radius:  10px; */
    height: 129px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 105px;
    }
    &.card-style-scheduled {
      background-color: #e1f6e6;
      border: 2px solid #1ec252;
    }
    .ant-card-body {
      padding: 18px 28px;
    }
  }
  .image-wrapper {
    position: relative;
    img {
      z-index: 0;
      position: absolute;
      top: 0;
      left: 0;
    }
    .image-resize {
      width: 115px;
      min-width: 115px;
      height: 94px;
      border-radius: 0 5px 5px 0;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 82px;
        min-width: 82px;
        height: 67px;
        border-radius: 0 4px 4px 0;
      }
      &.image-background {
        background-size: cover;
        background-repeat: no-repeat;
        z-index: 1;
        position: relative;
      }
    }
  }
  .dark-gray-img {
    background: darkgray;
    padding: 15px;
  }
  .grey-text {
    font-family: 'Roboto';
    padding-left: 10px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 10px;
    }
    .green-mail-text {
      color: #1ec252;
      font-weight: 500;
    }
    &.with-subject {
      padding-top: 30px;
      span {
        font-weight: 500;
        margin-left: 5px;
        color: #67696a;
      }
    }
  }
  .toggle-show {
    cursor: pointer;
    color: #1ec252;
    text-align: center;
    font-family: Roboto;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid #1ec252;
    background-color: #d8f0de;
    border-radius: 0px 0px 8px 8px;
    padding: 3px;
  }
`;
